import { render, staticRenderFns } from "./coopList.vue?vue&type=template&id=0febb050&scoped=true&"
import script from "./coopList.vue?vue&type=script&lang=js&"
export * from "./coopList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0febb050",
  null
  
)

export default component.exports